import React from 'react';
import './NewtonsCradleLoader.css';

const NewtonsCradleLoader = ({ size = '32px', color = '#8b0000' }) => {
  return (
    <div className="newtons-cradle" style={{ '--uib-size': size, '--uib-color': color }}>
      <div className="newtons-cradle__dot"></div>
      <div className="newtons-cradle__dot"></div>
      <div className="newtons-cradle__dot"></div>
      <div className="newtons-cradle__dot"></div>
    </div>
  );
};

export default NewtonsCradleLoader;
